<template>
  <div class="menu-container">
    <template v-for="(v,index) in menuList">
      <el-submenu :index="v.name" v-if="v.children&&v.children.length&&v.meta.isShowChildren" :key="v.name">
        <template slot="title" v-if="v.meta.isShow">
          <i class="iconfont" :class="v.meta.icon"></i>
          <span>{{v.meta.name}}</span>
        </template>
        <el-menu-item-group>
          <my-nav :menuList="v.children"></my-nav>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item :key="v.name" :index="v.name" @click="gotoRoute(v.name,index)" v-else-if="v.meta.isShow">
        <!-- <i class="iconfont" :class="v.meta.icon"></i> -->
        <img :src="v.meta.icon" v-show="menuIndex!=index" />
        <img :src="v.meta.icon_c" v-show="menuIndex==index" />
        <span slot="title">{{v.meta.name}}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'my-nav',
  props: {
    menuList: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  computed: {
    ...mapState('permission', ['sidebarMenu', 'currentMenu'])
  },
  data () {
    return {
      menuIndex: 0
    };
  },
  mounted () {
    this.sidebarMenu.map((item, index) => {
      if (item.name == this.currentMenu) {
        this.menuIndex = index;
      }
    });
  },
  methods: {
    gotoRoute (name, index) {
      this.$router.push({ name });
      this.menuIndex = index;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dynamic-menu.vue